<template>
<div class="wrapper">

  <div class="row">
    <div class="col-12">
      <h3 v-if="msg">{{ msg }}</h3>
      <div v-else class="select-seminar form-section">
        <h3>Apply for </h3>
        <v-select v-model="seminar" @input="updateSeminar" name="seminar" :options="seminare" :get-option-label="({title}) => `${title}`" placeholder="Select seminar"></v-select>
      </div>
    </div>
  </div>

  <form v-if="seminar" action="#">

    <!-- User: -->
    <div class="form-section">

      <div class="row">
        <v-input v-model="user.vorname" name="user.vorname" label="First Name(s)" :required="true" placeholder="(as in passport)" autocomplete="off"></v-input>
        <v-input v-model="user.nachname" name="user.nachname" label="Family Name" :required="true" placeholder="(as in passport)"></v-input>
      </div>

      <div class="row">

        <div class="col-lg-6 col-12">
          <div class="input-wrapper" :class="{error: errors.has('user.citizenship')}">
            <div class="form-label">Nationality *</div>
            <v-select v-model="user.citizenship" name="citizenship" :options="countries" label="nameEn" placeholder="(as in passport)"></v-select>
            <span v-if="errors.has('user.citizenship')" class="error-msg">{{ errors.get('user.citizenship') }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="input-wrapper" :class="{error: errors.has('user.residence')}">
            <div class="form-label">Country of residence *</div>
            <v-select v-model="user.residence" name="residence" :options="countries" label="nameEn" placeholder="Select option"></v-select>
            <span v-if="errors.has('user.residence')" class="error-msg">{{ errors.get('user.residence') }}</span>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-lg-6 col-12">
          <div class="input-wrapper" :class="{error: errors.has('user.birthdate')}">
            <div class="form-label">Date of birth *</div>
            <datepicker @input="date => formatDateOn('user.birthdate', 'DD.MM.YYYY')(date)" :language="lang" minimum-view="day" maximum-view="year" initial-view="year" format="d. MMMM yyyy" input-class="form-control"></datepicker>
            <span v-if="errors.has('user.birthdate')" class="error-msg">{{ errors.get('user.birthdate') }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="input-wrapper" :class="{error: errors.has('user.sex')}">
            <div class="inline-elements">
              <div class="form-label">GENDER *</div>
              <div class="input-single inline-elements">
                <label class="radio-label">
                  <input v-model="user.sex" type="radio" value="1">
                  Female
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="input-single inline-elements">
                <label class="radio-label">
                  <input v-model="user.sex" type="radio" value="0">
                  Male
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="input-single inline-elements">
                <label class="radio-label">
                  <input v-model="user.sex" type="radio" value="?">
                  Diverse
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <span v-if="errors.has('user.sex')" class="error-msg">{{ errors.get('user.sex') }}</span>
          </div>
        </div>

      </div>

      <div class="row" v-if="user.sex === '?'">
        <div class="col-lg-6 col-12"></div>
        <v-input v-model="user.gender" addclass="mt-0" name="user.gender" placeholder="Specify if you wish..."></v-input>
      </div>

      <!-- Travel info -->
      <div class="form-section">

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-12">
                <div class="input-wrapper" :class="{error: errors.has('passport')}">
                  <div class="form-label">
                    Please upload a scan of the data page of your passport*
                  </div>
                </div>
              </div>
              <div class="col-12">
                <file-upload id="file-passport" class="box" @input="updatePassport" :multiple="false"></file-upload>
              </div>
              <div class="col-12">
                <div class="input-wrapper mt-0" :class="{error: errors.has('passport')}">
                  <span v-if="errors.has('passport')" class="error-msg">{{ errors.get('passport') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-12">
                <div class="input-wrapper" :class="{error: errors.has('photo')}">
                  <div class="form-label">
                    Please upload a recent photograph of yours*
                  </div>
                </div>
              </div>
              <div class="col-12">
                <file-upload id="file-photo" class="box" @input="updatePhoto" :multiple="false"></file-upload>
              </div>
              <div class="col-12">
                <div class="input-wrapper mt-0" :class="{error: errors.has('photo')}">
                  <span v-if="errors.has('photo')" class="error-msg">{{ errors.get('photo') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <v-input v-model="user.email" name="user.email" label="E-mail" type="email" :required="true">
        </v-input>
        <v-input v-model="user.phone" name="user.phone" label="Main phone number" type="number" prepend="+" :required="true"></v-input>
      </div>
    </div>

    <!-- Mailing address -->
    <!-- <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-section-label">Mailing Address</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.street" name="user.street" label="STREET + NO." :required="false"
              addclass="input-sm-margin"></v-input>
            <v-input v-model="user.postal" name="user.postal" label="POSTAL CODE" :required="false"
              addclass="input-sm-margin"></v-input>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.city" name="user.city" label="City" :required="false" addclass="input-sm-margin">
            </v-input>

            <div class="col-lg-6 col-12">
              <div class="input-wrapper input-sm-margin">
                <div class="form-label">Country</div>
                <v-select v-model="user.mailingcountry" name="mailingcountry" :options="countries" label="nameEn"
                  placeholder="Select option"></v-select>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->

    <!-- Phone Numbers -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-label">ADDITIONAL PHONE NUMBERS</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.phonehome" name="user.phonehome" label="Home" :required="false"
               type="number" prepend="+" columnclass="col-12" addclass="input-sm-margin"></v-input>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.phonemobile" name="user.phonemobile" label="Mobile" :required="false"
               type="number" prepend="+" columnclass="col-12" addclass="input-sm-margin"></v-input>
          </div>
        </div>
      </div>
    </div>

    <!-- Emergency contact -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-section-label">Emergency contact</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.emergencyname" name="user.emergencyname" label="Name" :required="true"
              addclass="input-sm-margin"></v-input>
            <v-input v-model="user.emergencycontact" name="user.emergencycontact" label="E-Mail"
              :required="true" addclass="input-sm-margin"></v-input>
          </div>
        </div>

        <!-- <v-input v-model="user.emergencyaddress" name="user.emergencyaddress" label="Address" :required="false"
          addclass="input-sm-margin"></v-input> -->
        <v-input v-model="user.emergencyphone" name="user.emergencyphone" label="Main phone number" :required="true"
          type="number" prepend="+" addclass="input-sm-margin"></v-input>

      </div>
    </div>

    <!-- Emergency Phone Numbers -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-label">ADDITIONAL PHONE NUMBERS</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.emergencyphone1" name="user.emergencyphone1" :required="false"
               type="number" prepend="+" columnclass="col-12" addclass="input-sm-margin"></v-input>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="row">
            <v-input v-model="user.emergencyphone2" name="user.emergencyphone2" :required="false"
               type="number" prepend="+" columnclass="col-12" addclass="input-sm-margin"></v-input>
          </div>
        </div>
      </div>
    </div>

    <br>
    <br>

    <!-- EDUCATION -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-section-label">MOST RECENT (OR CURRENT) HIGHER EDUCATION</div>
          </div>
        </div>
      </div>

      <recent-education v-model="education.recent"></recent-education>
    </div>

    <!-- Previous Experience -->
    <div class="form-section">
      <div class="row">
        <div class="col-12 input-wrapper">
          <div class="inline-elements">
            <div class="form-section-label">
              I HAVE PREVIOUSLY PARTICIPATED IN TRAINING COURSES, SEMINARS ETC.
              <br>
              WHICH ARE RELATED TO AND/OR RELEVANT FOR THE COURSE I AM APPLYING FOR: *
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="education.previous" type="radio" value="1">
                Yes
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="education.previous" type="radio" value="0">
                No
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-wrapper mt-0" :class="{error: errors.has('education.previous')}">
              <span v-if="errors.has('education.previous')" class="error-msg">{{ errors.get('education.previous') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="training-info" v-if="education.previous === '1'">
        <div class="row">
          <div class="col-12">
            <div class="input-wrapper">
              <div class="form-label">
                IF YES, PLEASE LIST MOST RECENT TRAINING COURSES, SEMINARS, ETC.
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.traininginyear1')}">
                  <div class="form-label">Year *</div>
                  <datepicker @input="date => formatDateOn('education.traininginyear1', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                  <span v-if="errors.has('education.traininginyear1')" class="error-msg">{{ errors.get('education.traininginyear1') }}</span>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.trainingincountry1')}">
                  <div class="form-label">Country *</div>
                  <v-select v-model="education.trainingincountry1" name="education.trainingincountry1"
                    :options="countries" label="nameEn" placeholder="Select option"></v-select>
                  <span v-if="errors.has('education.trainingincountry1')" class="error-msg">{{ errors.get('education.trainingincountry1') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.traininginstitution1" name="education.traininginstitution1" label="INSTITUTION"
                :required="true" addclass="input-sm-margin"></v-input>
              <v-input v-model="education.trainingdescription1" name="education.trainingdescription1" label="Description"
                :required="true" addclass="input-sm-margin"></v-input>
            </div>
          </div>
        </div>

        <div class="row" v-if="educationEntries > 1">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper">
                  <div class="form-label">Year</div>
                  <datepicker @input="date => formatDateOn('education.traininginyear2', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper">
                  <div class="form-label">Country</div>
                  <v-select v-model="education.trainingincountry2" name="education.trainingincountry2"
                    :options="countries" label="nameEn" placeholder="Select option"></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.traininginstitution2" name="education.traininginstitution2" label="INSTITUTION"
                :required="false"></v-input>
              <v-input v-model="education.trainingdescription2" name="education.trainingdescription2" label="Description"
                :required="false"></v-input>
            </div>
          </div>
        </div>

        <div class="row" v-if="educationEntries > 2">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper">
                  <div class="form-label">Year</div>
                  <datepicker @input="date => formatDateOn('education.traininginyear3', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper">
                  <div class="form-label">Country</div>
                  <v-select v-model="education.trainingincountry3" name="education.trainingincountry3"
                    :options="countries" label="nameEn" placeholder="Select option"></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.traininginstitution3" name="education.traininginstitution3" label="INSTITUTION"
                :required="false"></v-input>
              <v-input v-model="education.trainingdescription3" name="education.trainingdescription3" label="Description"
                :required="false"></v-input>
            </div>
          </div>
        </div>

        <div class="row" v-if="educationEntries > 3">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper">
                  <div class="form-label">Year</div>
                  <datepicker @input="date => formatDateOn('education.traininginyear4', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper">
                  <div class="form-label">Country</div>
                  <v-select v-model="education.trainingincountry4" name="education.trainingincountry4"
                    :options="countries" label="nameEn" placeholder="Select option"></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.traininginstitution4" name="education.traininginstitution4" label="INSTITUTION"
                :required="false"></v-input>
              <v-input v-model="education.trainingdescription4" name="education.trainingdescription4" label="Description"
                :required="false"></v-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <button class="btn-submit" type="button" @click.prevent="educationEntries++"  v-if="educationEntries < 4" style="width:auto;">
              <b>+</b> Add position
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Previous Attendence -->
    <div class="form-section">
      <div class="row">
        <div class="col-12 input-wrapper">
          <div class="inline-elements">
            <div class="form-section-label">
              I HAVE ALREADY PARTICIPATED IN AN ACP TRAINING COURSE
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="education.previousAspr" type="radio" value="1">
                Yes
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="education.previousAspr" type="radio" value="0">
                No
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-wrapper mt-0" :class="{error: errors.has('education.previousAspr')}">
              <span v-if="errors.has('education.previousAspr')" class="error-msg">{{ errors.get('education.previousAspr') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="training-info" v-if="education.previousAspr === '1'">
        <div class="row">
          <div class="col-12">
            <div class="input-wrapper">
              <div class="form-label">
                IF YES, PLEASE LIST
              </div>
            </div>
          </div>
        </div>

        <div class="row pb-3">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.aspryear1')}">
                  <div class="form-label">Year *</div>
                  <datepicker @input="date => formatDateOn('education.aspryear1', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                  <span v-if="errors.has('education.aspryear1')" class="error-msg">{{ errors.get('education.aspryear1') }}</span>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.asprCategory1')}">
                  <div class="form-label">Programm *</div>
                  <v-select v-model="education.asprCategory1" name="education.asprCategory1"
                    :options="asprCategories" label="name" placeholder="Select option"></v-select>
                  <span v-if="errors.has('education.asprCategory1')" class="error-msg">{{ errors.get('education.asprCategory1') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.asprCourse1" name="education.asprCourse1" label="NAME OF THE TRAINING COURSE"
                :required="true" columnclass="col-12" addclass="input-sm-margin"></v-input>
            </div>
          </div>
        </div>

        <div class="row pb-3"  v-if="asprEntries > 1">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.aspryear2')}">
                  <div class="form-label">Year</div>
                  <datepicker @input="date => formatDateOn('education.aspryear2', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                  <span v-if="errors.has('education.aspryear2')" class="error-msg">{{ errors.get('education.aspryear2') }}</span>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.asprCategory2')}">
                  <div class="form-label">Programm</div>
                  <v-select v-model="education.asprCategory2" name="education.asprCategory2"
                    :options="asprCategories" label="name" placeholder="Select option"></v-select>
                  <span v-if="errors.has('education.asprCategory2')" class="error-msg">{{ errors.get('education.asprCategory2') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.asprCourse2" name="education.asprCourse2" label="NAME OF THE TRAINING COURSE"
                :required="false" columnclass="col-12" addclass="input-sm-margin"></v-input>
            </div>
          </div>
        </div>

        <div class="row pb-3"  v-if="asprEntries > 2">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.aspryear3')}">
                  <div class="form-label">Year</div>
                  <datepicker @input="date => formatDateOn('education.aspryear3', 'YYYY')(date)" :language="lang" minimum-view="year" maximum-view="year" initial-view="year" format="yyyy"></datepicker>
                  <span v-if="errors.has('education.aspryear3')" class="error-msg">{{ errors.get('education.aspryear3') }}</span>
                </div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="input-wrapper input-sm-margin" :class="{error: errors.has('education.asprCategory3')}">
                  <div class="form-label">Programm</div>
                  <v-select v-model="education.asprCategory3" name="education.asprCategory3"
                    :options="asprCategories" label="name" placeholder="Select option"></v-select>
                  <span v-if="errors.has('education.asprCategory3')" class="error-msg">{{ errors.get('education.asprCategory3') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row">
              <v-input v-model="education.asprCourse3" name="education.asprCourse3" label="NAME OF THE TRAINING COURSE"
                :required="false" columnclass="col-12" addclass="input-sm-margin"></v-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <button class="btn-submit" type="button" @click.prevent="asprEntries++"  v-if="asprEntries < 3" style="width:auto;">
              <b>+</b> Add position
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- PROFESSIONAL POSITION -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-section-label">WHICH BEST DESCRIBES YOUR PROFFESIONAL BACKGROUND? *</div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Civilian Governmental -->
        <div class="col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single">
                  <label class="radio-label">
                    <input v-model="education.civilianGov" type="checkbox" value="1" false-value="" @change="updateProfession($event, 'civilianGov')">
                    <strong>CIVILIAN - GOVERNMENTAL</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Civilian NonGovernmental -->
        <div class="col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single">
                  <label class="radio-label">
                    <input v-model="education.civilianNonGov" type="checkbox" value="1" false-value="" @change="updateProfession($event, 'civilianNonGov')">
                    <strong>CIVILIAN - NONGOVERNMENTAL</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Civilian Intergovernmental -->
        <div class="col-12">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single">
                  <label class="radio-label">
                    <input v-model="education.civilian" type="checkbox" value="1" false-value="" @change="updateProfession($event, 'civilian')">
                    <strong>CIVILIAN INTERGOVERNMENTAL:</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <v-input v-model="education.civilianposition" name="education.civilianposition"
              placeholder="Please specify staff category and level/grade" :required="false"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin" :disabled="education.civilian !== true"></v-input>
          </div>
        </div>

        <!-- Police -->
        <div class="col-12">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single">
                  <label class="radio-label">
                    <input v-model="education.police" type="checkbox" value="1" false-value="" @change="updateProfession($event, 'police')">
                    <strong>POLICE:</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <v-input v-model="education.policerank" name="education.policerank" placeholder=" Please specify rank" :required="false"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin" :disabled="education.police !== true"></v-input>
          </div>
        </div>

        <!-- Military -->
        <div class="col-12">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single">
                  <label class="radio-label">
                    <input v-model="education.military" type="checkbox" value="1" false-value="" @change="updateProfession($event, 'military')">
                    <strong>MILITARY:</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <v-input v-model="education.militaryposition" name="education.militaryposition"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin" placeholder=" Please specify rank" :required="false" :disabled="education.military !== true"></v-input>
          </div>
        </div>

        <!-- Correction service -->
        <!-- <div class="col-12">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single">
                  <label class="radio-label">
                    <input v-model="education.correctionservice" type="checkbox" value="1" false-value="">
                    <strong>CORRECTION SERVICE:</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <v-input v-model="education.correctionservicerank" name="education.correctionservicerank" placeholder=" Please specify rank"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin" :required="false"></v-input>
          </div>
        </div> -->
      </div>

      <div class="input-wrapper mt-0 error" v-if="errors.has(['education.civilian', 'education.civilianGov', 'education.civilianNonGov', 'education.police', 'education.military'])">
          <span class="error-msg">One of the fields is required.</span>
      </div>

    </div>

    <!-- EXPERIENCE -->
    <recent-experience v-model="experience" :countries="countries"></recent-experience>

    <!-- Heard about  -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-section-label mb-4">HOW DID YOU LEARN ABOUT THIS COURSE? *</div>
          </div>
        </div>
      </div>

      <div class="row">

        <!-- Heard @ ACP Webise -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardasprwebsite" type="checkbox" value="1" false-value="">
                    <strong>ACP WEBSITE</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Heard @ Webise -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardwebsite" type="checkbox" value="1" false-value="">
                    <strong>OTHER WEBSITE</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <!-- <v-input v-model="course.heardwebsitevalue" name="course.heardwebsitevalue" :required="false" columnclass="col-lg-7 col-12" addclass="input-sm-margin"></v-input> -->
          </div>
        </div>

        <!-- Heard @ Social media -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardsocial" type="checkbox" value="1" false-value="">
                    <strong>SOCIAL MEDIA</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <!-- <v-input v-model="course.heardsocialvalue" name="course.heardsocialvalue" :required="false"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin"></v-input> -->
          </div>
        </div>

        <!-- Heard @ Emplyer -->
        <!-- <div class="col-lg-6 col-12 pb-3">
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardemployer" type="checkbox" value="1" false-value="">
                    <strong>EMPLOYER, SPECIFY:</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <v-input v-model="course.heardemployervalue" name="course.heardemployervalue" :required="false" addclass="input-sm-margin"></v-input>
          </div>
        </div> -->

        <!-- Heard @ Colleague -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardcolleague" type="checkbox" value="1" false-value="">
                    <strong>THROUGH COLLEAGUE</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Heard @ Officialy Nominated -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.nominated" type="checkbox" value="1" false-value="">
                    <strong>OFFICIALY NOMINATED</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <!-- <v-input v-model="course.nominatedFrom" name="course.nominatedFrom" :required="false"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin"></v-input> -->
          </div>
        </div>

        <!-- Heard @ Former course -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardformer" type="checkbox" value="1" false-value="">
                    <strong>FORMER COURSE PARTICIPANT</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <!-- <v-input v-model="course.heardformervalue" name="course.heardformervalue" :required="false"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin"></v-input> -->
          </div>
        </div>

        <!-- Heard @ Other -->
        <div class="col-12 pb-3">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="input-wrapper inline-elements input-sm-margin">
                <div class="input-single inline-elements">
                  <label class="radio-label">
                    <input v-model="course.heardother" type="checkbox" value="1" false-value="">
                    <strong>OTHER, PLEASE SPECIFY:</strong>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <v-input v-model="course.heardothervalue" name="course.heardothervalue" :required="false"
              columnclass="col-lg-7 col-12" addclass="input-sm-margin"></v-input>
          </div>
        </div>

      </div>

      <div class="input-wrapper mt-0 error" v-if="errors.has(['course.nominated', 'course.heardasprwebsite', 'course.heardcolleague', 'course.heardformer', 'course.heardother', 'course.heardsocial', 'course.heardwebsite'])">
          <span class="error-msg">One of the fields is required.</span>
      </div>

      <div class="row" v-if="course.nominated">
        <div class="col-12">
          <div class="input-wrapper" :class="{error: errors.has('letter')}">
            <div class="form-label">
              IF YOU HAVE BEEN OFFICIALY NOMINATED FOR THIS COURSE, PLEASE UPLOAD
              A LETTER OF SUPPORT FROM YOUR NOMINATOR
            </div>
          </div>
        </div>
        <div class="col-12">
          <file-upload id="file-letter" class="box" @input="updateLetter" :multiple="false"></file-upload>
        </div>
        <div class="col-12">
          <div class="input-wrapper mt-0" :class="{error: errors.has('letter')}">
            <span v-if="errors.has('passport')" class="error-msg">{{ errors.get('letter') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- LAnguage skills -->
    <div class="form-section">

      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <div class="form-section-label">ENGLISH LANGUAGE SKILLS (SCALE: 1=BASIC; 2=GOOD; 3=EXCELLENT)*</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-6 col-12 input-wrapper mt0" :class="{error: errors.has('course.understood')}">
          <div class="inline-elements">
            <div class="form-label">UNDERSTOOD:</div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.understood" type="radio" value="1">
                1
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.understood" type="radio" value="2">
                2
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.understood" type="radio" value="3">
                3
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <span v-if="errors.has('course.understood')" class="error-msg">{{ errors.get('course.understood') }}</span>
        </div>
        <div class="col-lg-3 col-md-6 col-12 input-wrapper mt0" :class="{error: errors.has('course.spoken')}">
          <div class="inline-elements">
            <div class="form-label">SPOKEN:</div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.spoken" type="radio" value="1">
                1
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.spoken" type="radio" value="2">
                2
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.spoken" type="radio" value="3">
                3
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <span v-if="errors.has('course.spoken')" class="error-msg">{{ errors.get('course.spoken') }}</span>
        </div>
        <div class="col-lg-3 col-md-6 col-12 input-wrapper mt0" :class="{error: errors.has('course.written')}">
          <div class="inline-elements">
            <div class="form-label">Written:</div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.written" type="radio" value="1">
                1
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.written" type="radio" value="2">
                2
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.written" type="radio" value="3">
                3
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <span v-if="errors.has('course.written')" class="error-msg">{{ errors.get('course.written') }}</span>
        </div>
        <div class="col-lg-3 col-md-6 col-12 input-wrapper mt0" :class="{error: errors.has('course.read')}">
          <div class="inline-elements">
            <div class="form-label">Read:</div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.read" type="radio" value="1">
                1
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.read" type="radio" value="2">
                2
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.read" type="radio" value="3">
                3
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <span v-if="errors.has('course.read')" class="error-msg">{{ errors.get('course.read') }}</span>
        </div>
      </div>
    </div>

    <hr>

    <!-- Financal support -->
    <div class="form-section">
      <div class="row">
        <div class="col-12 input-wrapper">
          <div class="form-section-label mb-5">
            ONLY APPLICABLE FOR IPT AND OSCE COURSES:
          </div>
          <div class="inline-elements">
            <div class="form-label">
              I WOULD LIKE TO APPLY FOR FINANCIAL SUPPORT (PLEASE BE AWARE OF THE CRITERIA AND
              APPLICATION DEADLINES FOR SCHOLARSHIPS ON OUR WEBSITE. WE CANNOT PROVIDE FINANCIAL SUPPORT FOR TRAVEL
              EXPENSES.)
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.financalsupport" type="radio" value="1">
                Yes
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="input-single inline-elements">
              <label class="radio-label">
                <input v-model="course.financalsupport" type="radio" value="0">
                No
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <!-- GDPR -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <v-checkbox v-model="user.gdprnews" value="1" name="user.gdprnews"
              label="Please send me the ACP NEWS and relevant information about future ACP training courses. I understand that my personal data will be processed and stored in accordance with the General Data Protection Regulation of the European Union and that I may revoke my consent any time."
              :required="false"></v-checkbox>
          </div>
        </div>

        <div class="col-12">
          <div class="input-wrapper">
            <v-checkbox v-model="user.gdprstorno" value="1" name="user.gdprstorno"
              label="I have read and accept the <a href='/en/business-and-cancellation-conditions/' target='_blank' rel='noopener'>terms and conditions.</a>" :required="true"></v-checkbox>
          </div>
        </div>

        <div class="col-12">
          <div class="input-wrapper">
            <v-checkbox v-model="user.gdprdaten" value="1" name="user.gdprdaten"
              label="By applying to this course I grant the ACP permission to store and process my personal data (including name, date of birth, nationality, email-address, education and employment) and to use it for the purposes of selection, evaluation, and internal reference. The ACP may share information with relevant third parties when needed, such as donors, project partners and visa authorities. I understand that my personal data will be processed and stored in accordance with the <a href='/en/privacy-policy/' target='_blank' rel='noopener'>General Data Protection Regulation of the European Union.</a>"
              :required="true"></v-checkbox>
          </div>
        </div>
      </div>

    </div>

    <!-- Submit: -->
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12 input-wrapper">
        <button @click.prevent="submit" class="btn-submit" :disabled="loading" style="display:flex">
          <span>APPLY</span>
          <span class="arrow"></span>
        </button>
      </div>
    </div>

  </form>

</div>
</template>

<script>
import {
  createNamespacedHelpers
} from 'vuex'

import moment from 'moment'
import VInput from './fields/VInput'
import VCheckbox from './fields/VCheckbox'
import vSelect from 'vue-select'
import RecentExperience from './sections/RecentExperience'
import RecentEducation from './sections/RecentEducation'
import FileUpload from './fields/FileUpload'

import Datepicker from 'vuejs-datepicker'
import { en } from 'vuejs-datepicker/dist/locale'

const {
  mapState,
  mapActions
} = createNamespacedHelpers('advancedonlineform')

export default {
  name: 'AdvancedOnlineForm',
  inject: [
    'errors'
  ],
  components: {
    VInput,
    vSelect,
    VCheckbox,
    Datepicker,
    FileUpload,
    RecentEducation,
    RecentExperience
  },

  props: {
    msg: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      lang: en,
      seminar: null,
      asprEntries: 1,
      educationEntries: 1,
      user: {
        vorname: '',
        nachname: '',
        citizenship: '',
        residence: '',
        birthdate: '',
        sex: '',
        gender: '',
        email: '',
        phone: '',
        phonework: '',
        phonehome: '',
        phonemobile: '',
        phonefax: '',
        street: '',
        postal: '',
        city: '',
        mailingcountry: '',
        emergencyname: '',
        emergencycontact: '',
        emergencyaddress: '',
        emergencyphone: '',
        emergencyphone1: '',
        emergencyphone2: '',
        gdprnews: '',
        gdprstorno: '',
        gdprdaten: ''
      },
      education: {
        previous: null,
        previousAspr: null,
        degree: '',
        schoolname: '',
        aspryear1: '',
        aspryear2: '',
        aspryear3: '',
        asprCategory1: '',
        asprCategory2: '',
        asprCategory3: '',
        asprCourse1: '',
        asprCourse2: '',
        asprCourse3: '',
        traininginyear1: '',
        trainingincountry1: '',
        traininginstitution1: '',
        trainingdescription1: '',
        traininginyear2: '',
        trainingincountry2: '',
        traininginstitution2: '',
        trainingdescription2: '',
        traininginyear3: '',
        trainingincountry3: '',
        traininginstitution3: '',
        trainingdescription3: '',
        traininginyear4: '',
        trainingincountry4: '',
        traininginstitution4: '',
        trainingdescription4: '',
        civilian: '',
        civilianGov: '',
        civilianNonGov: '',
        civilianposition: '',
        police: '',
        policerank: '',
        military: '',
        militaryposition: '',
        correctionservice: '',
        correctionservicerank: '',
        recent: []
      },
      experience: {
        from: '',
        to: '',
        country: '',
        employer: '',
        position: '',
        maintask: '',
        operations: '',
        reasons: ''
      },
      course: {
        heardemployer: '',
        heardemployervalue: '',
        heardsocial: '',
        heardsocialvalue: '',
        heardasprwebsite: '',
        heardwebsite: '',
        heardwebsitevalue: '',
        heardcolleague: '',
        heardcolleaguevalue: '',
        heardformer: '',
        heardformervalue: '',
        heardother: '',
        heardothervalue: '',
        understood: '',
        spoken: '',
        written: '',
        read: '',
        financalsupport: '',
        nominated: '',
        nominatedFrom: ''
      }
    }
  },

  computed: {
    ...mapState(['advancedonlineform', 'countries', 'seminare', 'loading']),
    asprCategories () {
      return [
        { id: 1, name: 'ENTRi' },
        { id: 2, name: 'ESDC' },
        { id: 3, name: 'EUAV' },
        { id: 4, name: 'EUCTI' },
        { id: 5, name: 'EUPCST' },
        { id: 6, name: 'IPT' },
        { id: 7, name: 'OSCE SAC' },
        { id: 8, name: 'Other' }
      ]
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    ...mapActions([
      'sendForm',
      'fetchData',
      'updateForm',
      'updateUser',
      'updateCourse',
      'updateSeminar',
      'updateEducation',
      'updateExperience'
    ]),
    updatePhoto (photo) {
      this.updateForm(['photo', photo])
    },
    updatePassport (passport) {
      this.updateForm(['passport', passport])
    },
    updateDocuments (documents) {
      this.updateForm(['documents', documents])
    },
    updateDeclaration (declaration) {
      this.updateForm(['declaration', declaration])
    },
    updateLetter (letter) {
      this.updateForm(['letter', letter])
    },
    async submit () {
      var response = await this.sendForm()
      response.success && this.$router.push('thankyou')
    },
    formatDateOn (field, format) {
      return date => {
        const value = moment(date).format(format)
        const parts = field.split('.')
        if (parts.length === 1) {
          this[field] = value
        } else {
          this[parts[0]][parts[1]] = value
        }
      }
    },
    updateProfession (ev, profession) {
      if (ev.target.checked) {
        const professionCheckboxes = [
          'civilian', 'civilianGov', 'civilianNonGov', 'police', 'military'
        ]
        const index = professionCheckboxes.indexOf(profession)
        if (index > -1) {
          professionCheckboxes.splice(index, 1)
          professionCheckboxes.forEach(prof => {
            this.education[prof] = null
          })
        }
      }
    }
  },

  watch: {
    user: {
      deep: true,
      handler: function (user) {
        if (user.sex !== '?') {
          user.gender = ''
        }
        this.updateUser({ user })
      }
    },
    education: {
      deep: true,
      handler: function (education) {
        if (education.previous === '0') {
          this.educationEntries = 1
        }
        if (education.previousAspr === '0') {
          this.asprEntries = 1
        }
        this.updateEducation({ education })
      }
    },
    experience: {
      deep: true,
      handler: function (experience) {
        this.updateExperience({ experience })
      }
    },
    course: {
      deep: true,
      handler: function (course) {
        this.updateCourse({ course })
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  $vs-state-active-bg: rgba(60, 60, 60, 0.26);
  @import '~vue-select/src/scss/vue-select';
}
</style>

<style lang="scss" scoped>
.input-wrapper {
  &.error {
    input {
      border-color: #c2063b;
    }
  }

  .error-msg {
    color: #c2063b;
    font-size: 15px;
    display: block;
  }
}
.select-seminar {
  margin-bottom: 15px;
}
</style>
